/** 
*@author: Sirisha.M
*@Description : 
**/
/* eslint-disable no-unused-vars */
import axios from 'axios';
import Asset from './Forms/Asset';
import Device from './Forms/Device';
import { connect } from 'react-redux';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import UploadAssets from './Forms/UploadAssets';
import { GetDefaultHierarchy } from './APICalls';
import UploadDevices from './Forms/UploadDevices';
import localStorage from '../../utils/localStorage';
// import themeSettings from "../../../commons/styles/themeSettings.json";
import { API_HIERARCHYMODULE } from '../../commons/api';
import {
  Button,
  message,
  Modal,
  Popconfirm,
  Tooltip,
  Tree,
  Form,
  Select,
  Input
} from 'antd';
import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  UploadOutlined,
  ExportOutlined,
  ImportOutlined
} from '@ant-design/icons';

const { Option } = Select;

const CustomerAssetDeviceComponent = (props) => {
  const [treeData, setTreeData] = useState({});
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [ShowForm, setShowForm] = useState('');
  const [Module, setModule] = useState('');
  const [SelectedLevel, setSelectedLevel] = useState('');
  const [SelectedStatus, setSelectedStatus] = useState('');
  const [visible, setVisible] = useState(false);
  const [Move_Visible, setMoveVisible] = useState(false);
  const [Back_Visible, setBackVisible] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [Assetslist, setAssetslist] = useState([]);
  const [levelsList, setLevelsList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedShowForm, setSelectedShowForm] = useState('');
  const [selectedParent, setSelectedParent] = useState({});
  const [ModuleCode, setModuleCode] = useState('');
  const [SelectedAsset, setSelectedAsset] = useState('');
  const [selectedType, setSelectedType] = useState('');
  const [BackItem, setBackItem] = useState({});
  const [MovedItem, setMovedItem] = useState({});
  const [foundObject, setFoundObject] = useState({});
  const [selectStatus, setSelectStatus] = useState('');
  const [parent, setParent] = useState({});
  const [state, setState] = useState({
    ShowForm: null,
    formTypeName: '',
    selectedRow: null,
    DeviceType: '', // Initialize with your default value
    Module: '' // Initialize with your default value
  });
  const LevelRef = useRef();
  const MoveRef = useRef();
  const BackRef = useRef();

  useEffect(() => {
    GetHierarchyLevels('initial');
  }, []);
  useEffect(() => {
    GetHierarchyLevels('initial');
  }, [props.match.params.module]);


  const getLevelsData = async (key, Code) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `/api/rubusMaster/hierarchy/getLevelsByKey?SiteId=${siteId}&key=${key}&ModuleCode=${Code}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(headers)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const getStatusData = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `/api/rubusMaster/modules/getDefaultModules?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(headers)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const moveSubmit = async () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'PATCH',
      url: `/api/client/asset/updateStatus?SiteId=${siteId}&Status=${SelectedStatus}&Id=${MovedItem.Id}&ModuleCode=${treeData[0].ModuleCode}&Type=${MovedItem.Type}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(headers)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const onBackSubmit = async (value, type) => {

    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `/api/client/depo/getAssetsByParent?SiteId=${siteId}&key=${BackItem.moduleKey}&ModuleCode=${treeData[0].ModuleCode}&DefaultModuleCode=${value}&Type=${type}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(headers)
      .then((response) => {
        return response.data;
      })
      .catch(function () { });
  };

  const getHierarchyLevels = async (Module, refereshStatus) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let defaultHiearchyCode = await GetDefaultHierarchy();
    let HierarchyCode =
      defaultHiearchyCode && defaultHiearchyCode[0] && defaultHiearchyCode[0].HierarchyCode
        ? defaultHiearchyCode[0].HierarchyCode
        : '';
    let headers = {
      method: 'GET',
      url: `${API_HIERARCHYMODULE.GetModuleClientHierarchy}?SiteId=${siteId}&HierarchyCode=${HierarchyCode}&Module=${Module}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          if (refereshStatus === 'initial') expandAll(data);
          const addActions = (data) => {
            return data.map((item) => {
              // Add Actions based on Type
              if (item.Type === 'Module') {
                if (item.hasChild <= 0) {
                  item.Actions = {
                    UPLOAD_ASSETS: 'Upload Assets'
                  };
                }
                if (item.hasChild > 0) {
                  item.Actions = {
                    ADD_LOCATION: 'Add',
                    UPLOAD_ASSETS: 'Upload Assets'
                  };
                }
              } else if (item.Type === 'Asset') {
                if (item.hasChild <= 0) {
                  item.Actions = {
                    EDIT_LOCATION: `Edit Asset `,
                    MOVE: 'Move',
                    BACK: 'Back',
                    UPLOAD_ASSETS: 'Upload Asset',
                    DELETE_ASSET: 'Delete Asset'
                  };
                }
                if (item.hasChild > 0) {
                  item.Actions = {
                    EDIT_LOCATION: 'Edit Asset',
                    MOVE: 'Move',
                    BACK: 'Back',
                    ADD_SUBLOCATION: 'Add',
                    UPLOAD_ASSETS: 'Upload Assets',
                    DELETE_ASSET: 'Delete Asset',
                  };
                }
              } else if (item.Type === 'DeviceType') {
                item.Actions = {
                  ADD_DEVICE: 'Add',
                  UPLOAD_DEVICES: 'Upload Devices'
                };
              } else if (item.Type === 'Device') {
                item.Actions = {
                  EDIT_DEVICE: 'Edit device',
                  MOVE: 'Move',
                  DELETE_DEVICE: 'Delete device'
                };
              }

              // Recursively process children
              if (item.children && item.children.length > 0) {
                item.children = addActions(item.children);
              }

              return item;
            });
          };

          // Usage
          const updatedJson = addActions(data);

          setTreeData(updatedJson);
          setModule(Module);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const GetHierarchyLevels = (refereshStatus) => {
    let string = props && props.match && props.match.pathname;
    let mainString = string.replace('/rubus/CustomerAssetDeviceConfiguration/', '');
    getHierarchyLevels(mainString, refereshStatus);
  };

  const expandAll = async (treeData) => {
    const expandedKeys =
      treeData &&
      Array.isArray(treeData) &&
      treeData.map((node) => {
        return node.Id;
      });

    setExpandedKeys(expandedKeys);
  };

  // const getAllKeys = (data) => {
  //   const nestedKeys = data.map((node) => {
  //     let childKeys = [];
  //     if (node.children) {
  //       childKeys = getAllKeys(node.children);
  //     }
  //     return [childKeys, node.Id];
  //   });
  //   return flattenDeep(nestedKeys);
  // };

  const deleteAssetDevice = async (Type, Item) => {
    const token = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    var Authorization = 'Bearer ' + token;

    let data = {
      url: `/api/${Type}/delete?SiteId=${siteId}&AliasCode=${Item.Code}`,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: Authorization
      }
    };
    return axios(data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        message.error(err.response.data.message);
      });
  };

  const getIcon = (ShowForm, item) => {
    let findAssetMatch = JSON.stringify(ShowForm).match(`DELETE_ASSET`) !== null;
    let findDeviceMatch = JSON.stringify(ShowForm).match(`DELETE_DEVICE`) !== null;
    // let findUploadParamMatch = JSON.stringify(ShowForm).match(`UPLOAD_PARAMETERS`) !== null;
    let findADDMatch = JSON.stringify(ShowForm).match(`ADD`) !== null;
    let findEDITMatch = JSON.stringify(ShowForm).match(`EDIT`) !== null;
    let findUPLOADMatch = JSON.stringify(ShowForm).match(`UPLOAD`) !== null;
    let findDELETEMatch = JSON.stringify(ShowForm).match(`DELETE`) !== null;
    let findMOVEMatch = JSON.stringify(ShowForm).match(`MOVE`) !== null;
    let findBACKMatch = JSON.stringify(ShowForm).match(`BACK`) !== null;

    if (findADDMatch === true) {
      return <PlusOutlined />;
      // } else if (findUploadParamMatch === true) {
      //   return <ToTopOutlined />;
    } else if (findEDITMatch === true) {
      return <EditOutlined />;
    } else if (findMOVEMatch === true) {
      return <ExportOutlined />;
    } else if (findBACKMatch === true) {
      return <ImportOutlined />;
    } else if (findUPLOADMatch === true) {
      return <UploadOutlined />;
    } else if (findDELETEMatch === true) {
      return (
        <Popconfirm
          title="Are you sure to delete？"
          placement="bottom"
          onConfirm={async () => {
            let deleteStatus = {};
            if (findAssetMatch === true) {
              deleteStatus = await deleteAssetDevice('asset', item);
            } else if (findDeviceMatch === true) {
              deleteStatus = await deleteAssetDevice('device', item);
            }
            if (deleteStatus && deleteStatus.message) {
              message.success(deleteStatus.message);
              GetHierarchyLevels();
            }
          }}
          okText="Yes"
          cancelText="No"
          icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
        >
          <DeleteOutlined />
        </Popconfirm>
      );
    } else {
      return null;
    }
  };

  const getFormTypeName = (ShowForm) => {
    let checkAdd = ShowForm.split('ADD_');
    let checkEdit = ShowForm.split('EDIT_');
    let ftName = '';
    if (checkAdd && Array.isArray(checkAdd) && checkAdd.length === 2) {
      ftName = checkAdd[1];
    } else if (checkEdit && Array.isArray(checkEdit) && checkEdit.length === 2) {
      ftName = checkEdit[1];
    }
    return ftName;
  };

  const onAction = (ShowForm, item, parent) => {
    let findADDMatch = JSON.stringify(ShowForm).match(`ADD`) !== null;
    let findEDITMatch = JSON.stringify(ShowForm).match(`EDIT`) !== null;
    let findUPLOADMatch = JSON.stringify(ShowForm).match(`UPLOAD`) !== null;

    let stateValues = {
      ShowForm
    };
    let formTypeName = getFormTypeName(ShowForm);
    if (findADDMatch === true) {
      stateValues = {
        ...stateValues,
        formTypeName,
        selectedRow: item
      };
    } else if (findEDITMatch === true) {
      stateValues = {
        ...stateValues,
        formTypeName,
        selectedRow: item
      };
    } else if (findUPLOADMatch === true) {
      stateValues = {
        ...stateValues,
        selectedRow: { ...item, DeviceType: state.DeviceType, Module: state.Module }
      };
    }
    setState(prevState => ({
      ...prevState,
      ...stateValues,
      parent
    }));
    setSelectedRow(item);
    setShowForm(ShowForm);
    setParent(parent);
  };

  const renderTreeNodes = (data, parent) => {
    return (
      data &&
      Array.isArray(data) &&
      data.map((item) => {
        if (item && item.children && item.children.length > 0) {
          return (
            <Tree.TreeNode
              title={
                <>
                  {item.Name}
                  <>
                    {item && item.Actions && Object.keys(item.Actions)
                      ? Object.keys(item.Actions).map((ShowForm, index) => {
                        return (
                          <Tooltip
                            key={index}
                            title={`
                            ${translation(item.Actions[ShowForm])}`}
                          >
                            <Button

                              onClick={async () => {
                                if (ShowForm && ShowForm === 'ADD_LOCATION') {
                                  let levelsList = await getLevelsData(
                                    item.moduleKey,
                                    treeData[0].ModuleCode
                                  );
                                  setVisible(true);
                                  setLevelsList(levelsList);
                                  setSelectedShowForm(ShowForm);
                                  setSelectedItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else if (ShowForm && ShowForm === 'MOVE') {
                                  let statusList = await getStatusData();
                                  setMoveVisible(true);
                                  setStatusList(statusList);
                                  setSelectedShowForm(ShowForm);
                                  setMovedItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else if (ShowForm && ShowForm === 'BACK') {
                                  let statusList = await getStatusData();
                                  BackRef.current &&
                                    BackRef.current.setFieldsValue({
                                      Status: undefined,
                                      Id: undefined,
                                      Name: undefined,
                                      DisplayCode: undefined,
                                      Type: undefined
                                    });
                                  setBackVisible(true);
                                  setSelectedAsset(undefined);
                                  setSelectedStatus(undefined);
                                  setSelectedType(undefined);
                                  setStatusList(statusList);
                                  setSelectedShowForm(ShowForm);
                                  setBackItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else if (ShowForm && ShowForm === 'ADD_SUBLOCATION') {
                                  let levelsList = await getLevelsData(
                                    item.moduleKey,
                                    treeData[0].ModuleCode
                                  );

                                  setVisible(true);
                                  setLevelsList(levelsList);
                                  setSelectedShowForm(ShowForm);
                                  setSelectedItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else {
                                  onAction(ShowForm, item, parent);
                                }
                              }}
                              style={{
                                marginLeft: '5px',
                                background: '#285a8c',
                                borderColor: '#1a3652'
                              }}
                            >
                              {getIcon(ShowForm, item)}
                            </Button>
                          </Tooltip>
                        );
                      })
                      : null}
                  </>
                </>
              }
              key={item.Id}
              dataRef={item}
            >
              {renderTreeNodes(item.children, item)}
            </Tree.TreeNode>
          );
        }
        return (
          <Tree.TreeNode
            key={item.key}
            title={
              <div>
                <>
                  {item.Name}
                  <>
                    {item &&
                      item.Actions &&
                      Object.keys(item.Actions) &&
                      Object.keys(item.Actions).length > 0
                      ? Object.keys(item.Actions).map((ShowForm, index) => {
                        return (
                          <Tooltip key={index} title={translation(item.Actions[ShowForm])}>
                            <Button

                              onClick={async () => {
                                if (
                                  (ShowForm && ShowForm === 'ADD_LOCATION') ||
                                  (ShowForm && ShowForm === 'ADD_SUBLOCATION')
                                ) {
                                  let levelsList = await getLevelsData(
                                    item.moduleKey,
                                    treeData[0].ModuleCode
                                  );

                                  setVisible(true);
                                  setLevelsList(levelsList);
                                  setSelectedShowForm(ShowForm);
                                  setSelectedItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else if (ShowForm && ShowForm === 'MOVE') {
                                  let statusList = await getStatusData();
                                  setMoveVisible(true);
                                  setStatusList(statusList);
                                  setSelectedShowForm(ShowForm);
                                  setMovedItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else if (ShowForm && ShowForm === 'BACK') {
                                  let statusList = await getStatusData();
                                  BackRef.current &&
                                    BackRef.current.setFieldsValue({
                                      Status: undefined,
                                      Id: undefined,
                                      Name: undefined,
                                      DisplayCode: undefined,
                                      Type: undefined
                                    });
                                  setBackVisible(true);
                                  setSelectedAsset(undefined);
                                  setSelectedStatus(undefined);
                                  setSelectedType(undefined);
                                  setStatusList(statusList);
                                  setSelectedShowForm(ShowForm);
                                  setBackItem(item);
                                  setSelectedParent(parent);
                                  setModuleCode(treeData[0].ModuleCode);
                                } else {
                                  onAction(ShowForm, item, parent);
                                }
                              }}
                              style={{
                                marginLeft: '5px',
                                background: '#285a8c',
                                borderColor: '#1a3652'
                              }}
                            >
                              {getIcon(ShowForm, item)}
                            </Button>
                          </Tooltip>
                        );
                      })
                      : null}
                  </>
                </>
              </div>
            }
            dataRef={item}
          />
        );
      })
    );
  };

  const translation = (keyword) => {
    let { translationCache } = props;
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
  };

  const onModalOk = () => {
    if (SelectedLevel !== '' && SelectedLevel !== null) {
      onAction(
        selectedShowForm,
        selectedItem,
        selectedParent
      );

      LevelRef.current &&
        LevelRef.current.setFieldsValue({
          SelectLevel: null
        });
      setVisible(false);
      setShowForm(SelectedLevel);
      setSelectedLevel(null);
    } else {
      message.warn('Please Select Level');
    }
  };

  const onModalsOk = async () => {
    if (SelectedStatus !== '' && SelectedStatus !== null) {
      let submitResponse = await moveSubmit();
      message.success(submitResponse && submitResponse.message);
      GetHierarchyLevels();

      MoveRef.current &&
        MoveRef.current.setFieldsValue({
          Status: null
        });
      setMoveVisible(false);
      setShowForm(SelectedLevel);
      setSelectedStatus(null);
    } else {
      message.warn('Please Select Status');
    }
  };

  const onSubmitBackModel = async (formData, selectedType) => {
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const Object = {
      method: 'POST',
      url: `/api/client/depo/moveDepoData?SiteId=${siteId}&key=${BackItem.moduleKey}&ModuleCode=${treeData[0].ModuleCode}&ParentAsset=${BackItem.Code}&Type=${selectedType}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: {
        Name: formData.Name,
        DisplayCode: formData.DisplayCode,
        Id: formData.Id
      }
    };
    return axios(Object)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        message.info(err.response.data.message);
      });
  };

  const onBackModalsOk = async () => {
    if (SelectedAsset !== '' && SelectedAsset !== null) {
      let formData = BackRef.current && BackRef.current.getFieldsValue();
      let submitResponse = await onSubmitBackModel(formData, selectedType);
      if (submitResponse && submitResponse.status && submitResponse.status === 200) {
        message.success(submitResponse && submitResponse.data && submitResponse.data.message);
        GetHierarchyLevels();

        BackRef.current &&
          BackRef.current.setFieldsValue({
            Status: undefined,
            Id: undefined,
            Name: undefined,
            DisplayCode: undefined,
            Type: undefined
          });
        setBackVisible(false);
        setSelectedAsset(undefined);
        setSelectedStatus(undefined);
        setSelectedType(undefined);
      } else {
        message.error(submitResponse && submitResponse.data && submitResponse.data.message);
      }
    } else {
      message.warn('Please Select Asset');
    }
  };

  const onModalsCancel = () => {
    MoveRef.current &&
      MoveRef.current.setFieldsValue({
        Status: undefined
      });
    setMoveVisible(false);
    setSelectedStatus(undefined);
  };

  const onModalCancel = () => {
    LevelRef.current &&
      LevelRef.current.setFieldsValue({
        SelectLevel: null
      });
    setVisible(false);
    setSelectedLevel(null);
  };

  const onChange = (value) => {
    setSelectedLevel(value);
  };

  const onChangeMove = (value) => {
    setSelectedStatus(value);
  };

  const onBackModalsCancel = () => {
    BackRef.current &&
      BackRef.current.setFieldsValue({
        Status: undefined,
        Id: undefined,
        Name: undefined,
        DisplayCode: undefined,
        Type: undefined
      });
    setBackVisible(false);
    setSelectedAsset(undefined);
    setSelectedStatus(undefined);
    setSelectedType(undefined);
  };

  const onChangeAsset = (value) => {
    let foundObject = Assetslist && Assetslist.find((obj) => obj.Id === value);
    BackRef.current &&
      BackRef.current.setFieldsValue({
        Name: foundObject.Name,
        DisplayCode: foundObject.DisplayCode
      });
    setSelectedAsset(value);
    setFoundObject(foundObject);
  };

  const renderForm = (ShowForm, selectedRow, Module, translationCache, parent) => {
    switch (ShowForm) {
      case 'ADD_DEVICE':
        return (
          <Device
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            translationCache={translationCache}
            Module={treeData[0].ModuleCode}
            parent={parent}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'Device':
        return (
          <Device
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            translationCache={translationCache}
            Module={treeData[0].ModuleCode}
            parent={parent}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'EDIT_DEVICE':
        return (
          <Device
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            translationCache={translationCache}
            Module={treeData[0].ModuleCode}
            parent={parent}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'UPLOAD_DEVICES':
        return (
          <UploadDevices
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            Module={Module}
            parent={parent}
            translationCache={translationCache}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'UPLOAD_ASSETS':
        return (
          <UploadAssets
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            Module={Module}
            parent={parent}
            translationCache={translationCache}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'UPLOAD':
        return (
          <UploadAssets
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            Module={Module}
            parent={parent}
            translationCache={translationCache}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'EDIT_LOCATION':
        return (
          <Asset
            ModuleKey={treeData[0].moduleKey}
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            formTypeName={state.formTypeName}
            Module={treeData[0].ModuleCode}
            parent={parent}
            translationCache={translationCache}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      case 'Asset':
        return (
          <Asset
            ModuleKey={selectedRow.moduleKey}
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            formTypeName={state.formTypeName}
            Module={treeData[0].ModuleCode}
            parent={parent}
            translationCache={translationCache}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
      default:
        return (
          <Asset
            ModuleKey={treeData[0].moduleKey}
            selectedRow={selectedRow}
            ShowForm={ShowForm}
            formTypeName={state.formTypeName}
            Module={ModuleCode}
            parent={parent}
            translationCache={translationCache}
            GetHierarchyLevelsUpdated={GetHierarchyLevels}
          />
        );
    }
  };

  const onChangeBack = async (value) => {
    setSelectStatus(value);
  };

  const onChangeType = async (type) => {
    if (selectStatus !== '' && selectStatus !== null) {
      let submitResponse = await onBackSubmit(selectStatus, type);
      setAssetslist(submitResponse);

      BackRef.current &&
        BackRef.current.setFieldsValue({
          Id: undefined,
          Name: undefined,
          DisplayCode: undefined,
          Type: type
        });
      setSelectedAsset(undefined);
      setSelectedType(type);
    } else {
      message.warn('Please Select Status');
    }
  };

  return (
      <div style={{ padding: '10px', minHeight: window.innerHeight - 67 }}>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Modal
            open={visible}
            width={800}
            closable
            onOk={onModalOk}
            onCancel={onModalCancel}
          >
            <Form
              layout="horizontal"
              ref={LevelRef}
              name="user_form"
              labelCol={{ flex: '130px', marginTop: '20px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}>
                <Form.Item
                  style={{ width: '100%', flex: '50%' }}
                  label={'Select Levels'}
                  name={'SelectLevel'}
                >
                  <Select
                    style={{ width: '50%' }}
                    value={SelectedLevel}
                    placeholder={'Please Select Level'}
                    onChange={onChange}
                  >
                    {levelsList &&
                      Array.isArray(levelsList) &&
                      levelsList.map((device, index) => {
                        return (
                          <Option key={index} value={device.Code}>
                            {device.Name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </div>
            </Form>
          </Modal>
          <Modal
            open={Move_Visible}
            width={800}
            closable
            onOk={onModalsOk}
            onCancel={onModalsCancel}
          >
            <Form
              layout="horizontal"
              ref={MoveRef}
              name="user_form"
              labelCol={{ flex: '130px', marginTop: '20px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}>
                <Form.Item
                  style={{ width: '100%', flex: '50%' }}
                  label={'Select Status'}
                  name={'Status'}
                >
                  <Select
                    style={{ width: '50%' }}
                    value={SelectedStatus}
                    placeholder={'Please Select Status'}
                    onChange={onChangeMove}
                  >
                    {statusList &&
                      Array.isArray(statusList) &&
                      statusList.map((device, index) => {
                        return (
                          <Option key={index} value={device.Code}>
                            {device.Name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
              </div>
            </Form>
          </Modal>
          <Modal
            open={Back_Visible}
            width={800}
            closable
            onOk={onBackModalsOk}
            onCancel={onBackModalsCancel}
          >
            <Form
              layout="horizontal"
              ref={BackRef}
              name="user_form"
              labelCol={{ flex: '130px', marginTop: '20px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ marginTop: '24px' }}>
                <Form.Item
                  style={{ width: '100%', flex: '50%' }}
                  label={'Select Status'}
                  name={'Status'}
                  rules={[{ required: true }]}
                >
                  <Select
                    style={{ width: '50%' }}
                    value={SelectedStatus}
                    placeholder={'Please Select Status'}
                    onChange={onChangeBack}
                  >
                    {statusList &&
                      Array.isArray(statusList) &&
                      statusList.map((device, index) => {
                        return (
                          <Option key={index} value={device.Code}>
                            {device.Name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item
                  style={{ width: '100%', flex: '50%' }}
                  label={'Select Type'}
                  name={'Type'}
                  rules={[{ required: true }]}
                >
                  <Select
                    style={{ width: '50%' }}
                    value={selectedType}
                    placeholder={'Please Select Type'}
                    onChange={onChangeType}
                  >
                    <Option value={'Device'}>{'Device'}</Option>
                    <Option value={'Asset'}>{'Asset'}</Option>
                  </Select>
                </Form.Item>
                {selectedType ?
                  <Form.Item
                    style={{ width: '100%', flex: '50%' }}
                    label={`Select ${selectedType}`}
                    name={'Id'}
                    rules={[{ required: true }]}
                  >
                    <Select
                      style={{ width: '50%' }}
                      value={SelectedAsset}
                      placeholder={'Please Select Asset'}
                      onChange={onChangeAsset}
                    >
                      {Assetslist &&
                        Array.isArray(Assetslist) &&
                        Assetslist.map((device, index) => {
                          return (
                            <Option key={index} value={device.Id}>
                              {device.DisplayCode}
                            </Option>
                          );
                        })}
                    </Select>
                  </Form.Item>
                  : null}
                <Form.Item
                  style={{ width: '100%', flex: '50%' }}
                  label={'Name'}
                  name={'Name'}
                  rules={[{ required: true }]}
                >
                  <Input
                    value={foundObject && foundObject.Name}
                    style={{ width: '50%' }}
                    placeholder="Autopopulate based on Asset selection"
                  />
                </Form.Item>
                <Form.Item
                  style={{ width: '100%', flex: '50%' }}
                  label={'DisplayCode'}
                  name={'DisplayCode'}
                  rules={[{ required: true }]}
                >
                  <Input
                    value={foundObject && foundObject.DisplayCode}
                    style={{ width: '50%' }}
                    placeholder="Autopopulate based on Asset selection"
                  />
                </Form.Item>
              </div>
            </Form>
          </Modal>
          <div
            style={{
              width: '100%',
              flex: '25%',
              overflowY: 'auto',
              height: window.innerHeight - 87,
              background: props && props.themeValue && props.themeValue.components && props.themeValue.components.Menu
                ? props.themeValue.components.Menu.colorBgContainer : ""
            }}
          >
            <Tree
              style={{
                background: props && props.themeValue && props.themeValue.components && props.themeValue.components.Menu
                  ? props.themeValue.components.Menu.colorBgContainer : ""
              }}
              onExpand={onExpand}
              expandedKeys={expandedKeys}
              showLine
              defaultExpandAll={true}
              switcherIcon={<DownOutlined />}
            >
              {renderTreeNodes(treeData)}
            </Tree>
          </div>

          <div
            style={{
              flex: '75%',
              paddingLeft: '17px',
            }}
          >
            {selectedRow && Object.keys(selectedRow).length > 0
              ? renderForm(ShowForm, selectedRow, Module, props.translationCache, parent)
              : null}
          </div>
        </div>
      </div>
  );
};


const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  themeValue: state.ThemeReducer,
});

export default connect(mapStateToProps)(CustomerAssetDeviceComponent);